import React from 'react';
import './App.css';
import {Anchor} from "antd";
import {Home} from "./components/home/home";
import {Imprint} from "./components/imprint/imprint";

function App() {
    return (
        <div className="container">
            <Anchor
                replace
                items={[
                    {
                        key: 'home',
                        href: '#home',
                        title: 'Home',
                    },
                    // {
                    //     key: 'about',
                    //     href: '#about',
                    //     title: 'About',
                    // },
                    {
                        key: 'imprint',
                        href: '#imprint',
                        title: 'Impressum',
                    },
                    {
                        key: 'septaluna',
                        href: 'https://store.steampowered.com/app/3876940/Septaluna/',
                        title: 'Septaluna (Steam)',
                    },
                    {
                            key: 'blog',
                            href: 'https://blog.blazingtorch.io/',
                            title: 'Blog',
                    }
                ]}
            />
            <Home/>
            {/*<About/>*/}
            {/*<Games/>*/}
            <Imprint/>
        </div>
    );
}

export default App;
